import {
    Action,
    createReducer,
    on,
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Report } from './report.model';
import * as ReportActions from './report.actions';

export const reportsFeatureKey = 'reports';

export interface State extends EntityState<Report> {
    // additional entities state properties
    popupBlocker: boolean;
}

// have to specify function to get the uniqueid column since we're not using "id"
export const adapter: EntityAdapter<Report> = createEntityAdapter<Report>({
    selectId: (r: Report) => `${r.RptID}_${r.CatID}`
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    popupBlocker: false
});

const reportReducer = createReducer(
    initialState,
    on(ReportActions.addReport, (state, action) =>
        adapter.addOne(action.report, state)
    ),
    on(ReportActions.upsertReport, (state, action) =>
        adapter.upsertOne(action.report, state)
    ),
    on(ReportActions.addReports, (state, action) =>
        adapter.addMany(action.reports, state)
    ),
    on(ReportActions.upsertReports, (state, action) =>
        adapter.upsertMany(action.reports, state)
    ),
    on(ReportActions.updateReport, (state, action) =>
        adapter.updateOne(action.report, state)
    ),
    on(ReportActions.updateReports, (state, action) =>
        adapter.updateMany(action.reports, state)
    ),
    on(ReportActions.deleteReport, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(ReportActions.deleteReports, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(ReportActions.loadReports, (state, action) =>
        adapter.setAll(action.reports, state)
    ),
    on(ReportActions.clearReports, state => adapter.removeAll(state)),
    on(ReportActions.setPopupBlocker, (state, action) => ({
        ...state,
        popupBlocker: action.value
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return reportReducer(state, action);
}
export const reportState = createFeatureSelector<State>(reportsFeatureKey);
export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = adapter.getSelectors(reportState);

export const getPopupBlocker = createSelector(reportState, x => x.popupBlocker);
